import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { navLinks, site } from '@/mocks/site';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-foreground-950 flex items-center justify-center">
                <i className="ri-goblet-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-logo text-xl text-background-50">{site.brand}</span>
            </Link>
            <p className="text-sm leading-7 text-secondary-200 max-w-xs">
              按档期整理娱乐热点与福利内容的吃瓜门户，今日上新、本周推荐、周末限定、假日特辑一网打尽。
            </p>
            <p className="mt-5 text-sm text-secondary-300">
              <i className="ri-mail-line mr-2" aria-hidden="true"></i>
              {site.email}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              <Link to="/topics" className="hover:text-accent-300 transition-colors">档期栏目</Link>
            </h4>
            <ul className="space-y-3">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/topics?cat=${c.id}`}
                    className="text-sm text-secondary-200 hover:text-accent-300 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-300 transition-colors">站内导航</Link>
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-secondary-200 hover:text-accent-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/faq" className="text-sm text-secondary-200 hover:text-accent-300 transition-colors">
                  订阅与更新说明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-300 transition-colors">关于与联系</Link>
            </h4>
            <p className="text-sm leading-7 text-secondary-200">
              内容纠错、选题推荐或转载授权，欢迎通过邮箱与我们联系，我们会在两个工作日内回复。
            </p>
            <a
              href={`mailto:${site.email}`}
              className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 text-secondary-900 text-sm font-medium whitespace-nowrap hover:bg-accent-400 hover:text-foreground-950 transition-colors"
            >
              <i className="ri-send-plane-line" aria-hidden="true"></i>
              联系我们
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-300 text-center sm:text-left">
            © 2026 {site.brand} · 内容为娱乐观察与资讯整理，仅供交流参考
          </p>
          <p className="text-xs text-secondary-400">最近更新：{site.updated}</p>
        </div>
      </div>
    </footer>
  );
}